import ProjectModel from './ProjectModel'

export default class CompanyModel extends ProjectModel {
  foundedDate
  mailingAddress
  about
  logo
  employees

  constructor (obj) {
    super(obj)

    // Assume creation from JSON AJAX call
    const normalizedObj = CompanyModel.normalizeFromJS(obj)

    this.foundedDate = normalizedObj.foundedDate
    this.mailingAddress = normalizedObj.mailingAddress
    this.about = normalizedObj.about
    this.logo = normalizedObj.logo
    this.employees = normalizedObj.employees
    this.contactName = normalizedObj.contactName
    this.externalLink = normalizedObj.externalLink
  }

  static normalizeFromJS (obj) {
    const logo = {
      main: obj.logo_image,
      width: obj.logo_image_width,
      height: obj.logo_image_height
    }

    return {
      foundedDate: obj.founded_date,
      mailingAddress: obj.mailing_address,
      about: obj.about,
      logo,
      employees: obj.employees,
      contactName: obj.contact_name,
      externalLink: obj.external_link
    }
  }

  static fromJS (obj) {
    return new CompanyModel(obj)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/CompanyModel.js